import { Button, Card, List, Space, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import { useStockExpiring } from '@/api/generated/endpoints/stock/stock';
import { ExpiryTag } from '@/components/ExpiryTag';
import { QtyCell } from '@/components/qty';
import { EXPIRY_ORANGE_DAYS } from '@/lib/expiry';
import { CorrectionNotices } from '@/pages/CorrectionNotices';

/** Главная: что требует внимания склада сегодня. */
export function DashboardPage() {
  return (
    <Space direction="vertical" size="middle" style={{ width: '100%' }}>
      <CorrectionNotices />
      <ExpiringWidget />
    </Space>
  );
}

/** «Истекает скоро»: партии с остатком, срок которых кончается в ближайшие дни. */
function ExpiringWidget() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const expiring = useStockExpiring({ days: EXPIRY_ORANGE_DAYS, limit: 20 });
  return (
    <Card
      title={t('dashboard.expiringTitle', { days: EXPIRY_ORANGE_DAYS })}
      extra={
        <Button
          type="link"
          onClick={() => {
            void navigate('/stock');
          }}
        >
          {t('dashboard.toStock')}
        </Button>
      }
    >
      <Typography.Paragraph type="secondary">{t('dashboard.expiringHint')}</Typography.Paragraph>
      <List
        loading={expiring.isPending}
        dataSource={expiring.data?.items ?? []}
        locale={{ emptyText: t('dashboard.expiringEmpty') }}
        renderItem={(b) => (
          <List.Item>
            <Space wrap>
              <ExpiryTag expiresOn={b.expires_on} days={b.days_left} />
              <span>{b.product.name}</span>
              <Typography.Text type="secondary">{t('batch.title', { id: b.id })}</Typography.Text>
            </Space>
            <QtyCell value={b.qty_available} uom={b.product.base_uom} />
          </List.Item>
        )}
      />
    </Card>
  );
}
